import { FC, ReactNode } from 'react';
import styles from './care-now-programs-modal.module.scss';

type Props = {
  title: string;
  info: string;
  children?: ReactNode;
};

const CtaCard: FC<Props> = ({ title, info, children }: Props) => {
  return (
    <div className={styles.card}>
      <h2 className={styles['card-title']}>{title}</h2>
      <p className={styles['card-info']}>{info}</p>

      <div className={styles['card-btn']}>{children}</div>
    </div>
  );
};

export default CtaCard;
